import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from '../components/header/header';
import SidebarOperacion from '../components/header/sidebarOperacion';
import Permissions from '../middlewares/Permissions';
import PenalizationsTable from '../components/commonAreasPenalization/penalizationTable';
import Controls from '../components/controls/controls';
import Paginador from "../components/paginador/paginador";
import Core from './../components/core/SuperCore';
import DinamicModal from '../components/dinamicModal/dinamicModal';
import cogoToast from 'cogo-toast';
import moment from 'moment-timezone';
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { Consumer } from "../context";
import Request from "../core/httpClient";
import sortableData from '../helpers/sortableDataTable';
import { useSuperCore } from "../hooks/useSuperCore";
registerLocale('es', es);

const request = new Request();



const Penalizaciones = () => {
  const { getUserInfo, getSubmenuOpeName, openModal, closeModal } = useSuperCore();

 
  const [lectura, setLectura] = useState(false);
  const [escritura, setEscritura] = useState(false);
  const [user, setUser] = useState({});
  const [page, setPage] = useState(1);
  const [penalizaciones, setPenalizaciones] = useState([]);
  const [filter, setFilter] = useState("");
  const [subfraccionamientos, setSubfraccionamientos] = useState([]);
  const [idSubfraccionamiento, setIdSubfraccionamiento] = useState(0);
  const [idSubfraccionamientoTraerViviendas, setIdSubfraccionamientoTraerViviendas] = useState(localStorage.getItem("subfrac"));
  const [subfracLocked] = useState(Number(localStorage.getItem("subfrac") || 0));
  const [unidades, setUnidades] = useState([]);
  const [idUnidad, setIdUnidad] = useState(0);
  const [areas, setAreas] = useState([]);
  const [idArea, setIdArea] = useState(0);
  const [desde, setDesde] = useState(new Date());
  const [hasta, setHasta] = useState(new Date());
  const [pageLength, setPageLength] = useState(20);
  const [direction, setDirection] = useState({});
  const [filterColumn, setFilterColumn] = useState({});
  const [submenu, setSubmenu] = useState("");
  const [subLabel, setSubLabel] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [messageSave, setMessageSave] = useState("");


  useEffect(() => {
    const init = async () => {
      await validarPermisos();

      // submenu
      const submenuRes = await getSubmenuOpeName();
      if (submenuRes) setSubmenu(submenuRes);

      const subLabelRes = localStorage.getItem("subLabel");
      if (subLabelRes) setSubLabel(subLabelRes);

      // usuario
const userRes = await getUserInfo();
if (userRes?.info) {
  setUser({
    idUsuario: userRes.info.id_usuario,
    idPerfil: userRes.info.id_perfil,
    idFraccionamiento: userRes.info.id_fraccionamiento,
    nombre: userRes.info.usuario, // aquí usas "usuario" como nombre
  });
}


      const primerSub = await getSubfraccionamientos();
      await getPenalizaciones();
      await getUnidades(primerSub);
      await getAreasComunes(primerSub);
    };
    init();
  }, []);

  // 🔹 Métodos
  const validarPermisos = async () => {
    let permisos = new Permissions();
    let permisosInfo = await permisos.getResult();
    setEscritura(permisosInfo.escritura);
    setLectura(permisosInfo.lectura);
  };

  const handleFilter = (f) => setFilter(f.toLowerCase());

  const subChange = async (sub) => {
    setIdSubfraccionamiento(sub);
    setIdSubfraccionamientoTraerViviendas(sub); 
    setPage(1);
  };

  const paginatorChange = (length) => {
    setPageLength(length);
    setPage(1);
  };

  const reload = async () => {
    await getPenalizaciones();
  };

  const getSubfraccionamientos = async () => {
    try {
      const fraccionamiento = localStorage.getItem("frac");
      const subfraccionamiento = localStorage.getItem("subfrac");
      const subfraccionamientoLocked = subfracLocked || 0;

      if (!fraccionamiento) return;

      const data = { Idsub: fraccionamiento, filter: 1 };
      const response = await request.post("/admin/administracion/get/subfraccionamientos", data);

      if (response.error || response.empty) {
        setSubfraccionamientos([]);
        return;
      }

      if (response.subfraccionamiento) {
        const subfraccionamientoSeleccionado = subfraccionamiento || 0;
        const primerSub = response.subfraccionamiento[0]?.id_subfraccionamiento || 0;
        const subModal = subfraccionamientoLocked || primerSub;

        setSubfraccionamientos(response.subfraccionamiento);
        setIdSubfraccionamiento(subfraccionamientoSeleccionado);
        setIdSubfraccionamientoTraerViviendas(subModal);

        return subModal;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPenalizaciones = async () => {
    try {
      setLoading(true);
      const data = { id_fraccionamiento: localStorage.getItem("frac") };
      const response = await request.post("/commonArea/penalizaciones/obtener", data);

      if (response.penalizaciones) {
        setPenalizaciones(response.penalizaciones);
      } else {
        setPenalizaciones([]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const filterPenalizaciones = (items) => {
    const filtro = filter.toLowerCase();
    const selectedSub = Number(idSubfraccionamiento || 0);

    return items.filter((p) => {
      if (selectedSub && Number(p.id_subfraccionamiento) !== selectedSub) return false;

      const nombre = String(p.nombre || "").toLowerCase();
      const numeroRegistro = String(p.numero_registro || "").toLowerCase();
      const desdeStr = String(p.desde || "").toLowerCase();
      const hastaStr = String(p.hasta || "").toLowerCase();

      return (
        nombre.includes(filtro) ||
        numeroRegistro.includes(filtro) ||
        desdeStr.includes(filtro) ||
        hastaStr.includes(filtro)
      );
    });
  };

const sortableTable = (key) => {
  let sd = new sortableData();
  const { items, direction: dir } = sd.sortBy(key, penalizaciones, direction[key]);

  setPenalizaciones(items);
  setDirection({ [key]: dir });
  setFilterColumn({ col: key, filt: dir });
};

const changeSubfraccionamiento = async (event) => {
  const id_sub = event.target.value;
  setUnidades([]);
  setAreas([]);
  setIdUnidad(0);
  setIdArea(0);
  setIdSubfraccionamientoTraerViviendas(id_sub);

  await getUnidades(id_sub);
  await getAreasComunes(id_sub);
};

const getUnidades = async (idSub = idSubfraccionamientoTraerViviendas) => {
  try {
    setUnidades([]);
    setIdUnidad(0);

    const subfraccionamientoId = idSub ?? idSubfraccionamientoTraerViviendas;
    const data = {
      id_fraccionamiento: localStorage.getItem("frac"),
      id_subfraccionamiento: subfraccionamientoId,
    };

    const response = await request.post("/viviendas/getViviendaBySubFraccionamiento", data);

    if (response.empty || response.error) {
      setUnidades([]);
      cogoToast.info("No se encontraron viviendas en este fraccionamiento.", { position: "bottom-right" });
      return;
    }

    if (response.viviendas) {
      setUnidades(response.viviendas);
      setIdUnidad(response.viviendas[0].id_vivienda);
    }
  } catch (error) {
    console.log(error);
  }
};

const getAreasComunes = async (idSub = idSubfraccionamientoTraerViviendas || 0) => {
  try {
    setIdArea(0);
    setAreas([]);

    const subfraccionamientoId = idSub ?? idSubfraccionamientoTraerViviendas;
    const data = {
      id: localStorage.getItem("frac"),
      idsubfrac: subfraccionamientoId || 0,
    };

    const response = await request.post("/commonArea/get/info", data);

    if (response.empty || response.error) {
      setAreas([]);
      cogoToast.info("No se encontraron áreas comunes en este subfraccionamiento.", { position: "bottom-right" });
    }

    if (response.info) {
      setAreas(response.info);
      setIdArea(response.info[0]?.id_espacio || 0);
    }
  } catch (error) {
    console.log(error);
  }
};

const changeUnidad = (event) => setIdUnidad(event.target.value);
const changeAreaComun = (event) => setIdArea(event.target.value);

const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    setLoadingSave(true);

    if (desde > hasta) {
      cogoToast.warn("El rango de fechas no es válido.", { position: "bottom-right" });
      setLoadingSave(false);
      return;
    }

    const data = {
      idUsuario: user.idUsuario,
      idArea: idArea,
      idVivienda: idUnidad,
      desde: moment(desde).format("YYYY-MM-DD"),
      hasta: moment(hasta).format("YYYY-MM-DD"),
    };

    const response = await request.post("/commonArea/penalizaciones/agregar", data);

    if (response.created) {
      cogoToast.success("Penalización agregada.", { position: "bottom-right" });
      resetNewPenalizacionState(true);
      closeModal("newPenalizacion");
      reload();
    } else {
      cogoToast.error(response.message || "Error al agregar penalización.", { position: "bottom-right" });
    }

    setLoadingSave(false);
  } catch (error) {
    console.log(error);
  }
};
// Dentro del mismo Penalizaciones functional component

const resetNewPenalizacionState = async (useInitialSub = false, callback) => {
//   const lockedSub = subfracLocked || 0;
//   const currentSub = idSubfraccionamiento || idSubfraccionamientoTraerViviendas || 0;
//   const firstSub = subfraccionamientos[0]?.id_subfraccionamiento || currentSub;
 
  const subToUse = idSubfraccionamiento || subfracLocked || 0;

//   console.log("resetNewPenalizacionState → usando sub:", subToUse);

//   setIdSubfraccionamiento(subToUse);
  setIdSubfraccionamiento(subToUse);
  setIdUnidad(unidades[0]?.id_vivienda || 0);
  setIdArea(areas[0]?.id_espacio || 0);
  setDesde(new Date());
  setHasta(new Date());

  await getUnidades(subToUse);
  await getAreasComunes(subToUse);

  if (callback) callback();
};

const handleOpenNewPenalizacion = () => {
  resetNewPenalizacionState(false, () => openModal("newPenalizacion"));
};

const renderNewPenalizacion = () => (
<div className="flex w-full items-center">
  <div className="flex flex-col w-full space-y-4">
    {/* Subfraccionamiento */}
    <div className="flex w-full items-center gap-4">
      <div className="w-1/4 text-sm font-medium">
        <p><b>{subLabel}:</b></p>
      </div>
      <div className="flex-1">
        <select
          className="input-edit-select-full text-left"
          value={idSubfraccionamiento}
          disabled={true}
          required
        >
          {subfraccionamientos
            .filter(sub => sub.id_subfraccionamiento === Number(idSubfraccionamiento))
            .map((subfraccionamiento, key) => (
              <option value={subfraccionamiento.id_subfraccionamiento} key={key}>
                {subfraccionamiento.nombre}
              </option>
            ))}
        </select>
      </div>
    </div>

    {/* Vivienda */}
    <div className="flex w-full items-center gap-4">
      <div className="w-1/4 text-sm font-medium">
        <p><b>Vivienda:</b></p>
      </div>
      <div className="flex-1">
        <select
          className="input-edit-select-full text-left"
          value={idUnidad}
          onChange={changeUnidad}
          required
        >
          {unidades.map((unidad, key) => (
            <option value={unidad.id_vivienda} key={key}>
              {unidad.numero_registro}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Áreas */}
    <div className="flex w-full items-center gap-4">
      <div className="w-1/4 text-sm font-medium">
        <p><b>Áreas:</b></p>
      </div>
      <div className="flex-1">
        <select
          className="input-edit-select-full text-left"
          value={idArea}
          onChange={changeAreaComun}
          required
        >
          {areas.map((area, key) => (
            <option value={area.id_espacio} key={key}>
              {area.nombre}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Fechas */}
    <div className="flex w-full items-center gap-4 flex-wrap">
      <div className="w-1/6 text-sm font-medium">
        <p><b>Desde:</b></p>
      </div>
      <div className="flex-1">
        <DatePicker
          className="input-edit-select-full text-left"
          selected={desde}
          onChange={(fecha) => setDesde(fecha)}
          dateFormat="dd/MM/yyyy"
          locale="es"
          required
        />
      </div>

      <div className="w-1/6 text-sm font-medium ml-4">
        <p><b>Hasta:</b></p>
      </div>
      <div className="flex-1">
        <DatePicker
          className="input-edit-select-full text-left"
          selected={hasta}
          onChange={(fecha) => setHasta(fecha)}
          dateFormat="dd/MM/yyyy"
          locale="es"
          minDate={desde}
          required
        />
      </div>
    </div>
  </div>
</div>


);

return (
  <div className="houses column">
    <Helmet>
      <title>{process.env.REACT_APP_NAME} - {submenu}</title>
    </Helmet>
    <Header
      sidebar={true}
      active={"reservas"}
      parent={"areas"}
      panel={"panel3"}
      nav={"operacion"}
    />
    <div className="row">
      <div className="column" id="sidebar">
        <SidebarOperacion />
      </div>
      <div className="column" id="content">
        <div className="justify-center">
          <div className="container column">
            {lectura ? (
              <>
                <Controls
                  title={submenu}
                  nuevo={handleOpenNewPenalizacion}
                  dataSet={filterPenalizaciones(penalizaciones)}
                  setFilter={handleFilter}
                  subChange={subChange}
                  newButton={escritura}
                />
                {loading ? (
                  <div className="row justify-center">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <PenalizationsTable
                    penalizaciones={filterPenalizaciones(penalizaciones)}
                    page={page}
                    user={user}
                    reload={reload}
                    escritura={escritura}
                    pageLength={pageLength}
                    sortBy={sortableTable}
                    filterColumn={filterColumn}
                    subLabel={subLabel}
                  />
                )}
                <div className="white-space-16"></div>
                <Paginador
                  pages={Math.ceil(filterPenalizaciones(penalizaciones).length / pageLength)}
                  setPage={setPage}
                  pageLength={pageLength}
                  paginatorChange={paginatorChange}
                  showPageLenght={true}
                />
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
    <DinamicModal
      idModal={"newPenalizacion"}
      sizeModalContainer={"small"}
      title={"Añadir penalización"}
      success={handleSubmit}
      btnTextSuccess={"GUARDAR"}
      btnTextCancel={"CANCELAR"}
      showBtnSuccess={true}
      showBtnCancel={true}
      loadingSave={loadingSave}
      message={messageSave}
    >
      {renderNewPenalizacion()}
    </DinamicModal>
  </div>
);




  
};

export default Penalizaciones;










